// Non-production builds opt in explicitly; production keeps its current behavior.
export const IS_PREVIEW = process.env.REACT_APP_PREVIEW === 'true';
export const CONSOLIDATED_PLATFORM_ENABLED = process.env.REACT_APP_PLATFORM_VERSION === 'consolidated-v1';
export const ACCOUNT_DASHBOARD_ENABLED = IS_PREVIEW || CONSOLIDATED_PLATFORM_ENABLED;
export const CONTACT_ASSURANCE_ENABLED = process.env.REACT_APP_CONTACT_ASSURANCE_ENABLED === 'true';
export const SANDBOX_PAYMENTS_ENABLED = process.env.REACT_APP_SANDBOX_PAYMENTS_ENABLED === 'true';
export const PAYMENTS_ENABLED = !IS_PREVIEW || SANDBOX_PAYMENTS_ENABLED;

// Preferences can be explored only in the isolated development build; delivery stays disabled.
export const DEVELOPMENT_ALERT_PREFERENCES = process.env.REACT_APP_ENVIRONMENT === 'development';
export const MARKETPLACE_PREFERENCES_ENABLED = DEVELOPMENT_ALERT_PREFERENCES ||
  (CONSOLIDATED_PLATFORM_ENABLED && process.env.REACT_APP_MARKETPLACE_PREFERENCES_ENABLED === 'true');

// Shared Clerk availability flag. Placeholder keys disable authentication UI.
const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '';
export const CLERK_ENABLED =
  Boolean(CLERK_PUBLISHABLE_KEY) &&
  CLERK_PUBLISHABLE_KEY !== 'pk_test_placeholder' &&
  /^pk_(test|live)_/.test(CLERK_PUBLISHABLE_KEY);
export { CLERK_PUBLISHABLE_KEY };
